"use strict";

import initModulesInScope from '@elements/init-modules-in-scope';

export function initInScope ($scope) {
    let pendingRequest = null;
    let $hotspots = $scope.find('.js-hotspot');

    $scope.find('.js-hotspot__toggle').on('click', function (e) {
        e.preventDefault();
        let hotspotUrl = $(this).attr('data-hotspot-url');

        let $container = $scope.find('.js-hotspot__detail'),
            $loading = $container.find('.js-hotspot__loading'),
            $error = $container.find('.js-hotspot__error'),
            $result = $container.find('.js-hotspot__result');

        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }

        let ajaxUrl = hotspotUrl;

        $result.attr('hidden', null);
        $loading.attr('hidden', null);

        pendingRequest = $.ajax(ajaxUrl, {
            dataType: 'json',
            cache: true
        }).done(function (response) {
            if (response.content){
                $result.empty().append(response.content);

                if(!$(e.currentTarget).hasClass('is-open')) {
                    $hotspots.each(function () {
                        $(this).children(0).removeClass('is-open');
                    });

                    $(e.currentTarget).addClass('is-open');
                } else {
                    $(this).removeClass('is-open');
                }

                initModulesInScope($result);
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            if (textStatus !== 'abort') {
                $error.attr('hidden', null);
                console.error(textStatus, errorThrown, jqXHR);
            }
        }).always(function () {
            $loading.attr('hidden', 'hidden');
            pendingRequest = null;
        });
    });
}
